export default __webpack_public_path__ + "static/media/b.29e2baa2.jpg";